import script from "./ModalOrderSearchVan.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalOrderSearchVan.vue?vue&type=script&setup=true&lang=ts"

import "./ModalOrderSearchVan.vue?vue&type=style&index=0&id=e439c952&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e439c952"]])

export default __exports__